import ApiDefault from "../../ApiDefault";

export default function ApiLayoutsFiles() {
    const apiDefault = ApiDefault("v2/system/layouts-files");

    return {
        apiDefault,
    };
}
